
import { Transition } from "@headlessui/react";
import { useToastStore, type ToastVariant } from "@/stores/toastStore";

const variantStyles: Record<ToastVariant, { bg: string; icon: string; text: string }> = {
  success: {
    bg: "bg-success-subtle border-success",
    icon: "fa-solid fa-circle-check text-success",
    text: "text-success",
  },
  error: {
    bg: "bg-danger-subtle border-danger",
    icon: "fa-solid fa-circle-exclamation text-danger",
    text: "text-danger",
  },
  info: {
    bg: "bg-info-subtle border-info",
    icon: "fa-solid fa-circle-info text-info",
    text: "text-info",
  },
  warning: {
    bg: "bg-warning-subtle border-warning",
    icon: "fa-solid fa-triangle-exclamation text-warning",
    text: "text-warning",
  },
};

export function ToastContainer() {
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.removeToast);

  return (
    <div className="toast-container">
      {toasts.map((toast) => {
        const style = variantStyles[toast.variant];
        return (
          <Transition
            key={toast.id}
            appear
            show
            enter="toast-enter"
            enterFrom="toast-enter-from"
            enterTo="toast-enter-to"
            leave="toast-leave"
            leaveFrom="toast-leave-from"
            leaveTo="toast-leave-to"
          >
            <div
              className={`flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg bg-surface ${style.bg}`}
            >
              <i className={style.icon} />
              <span className="text-sm font-medium flex-1">{toast.message}</span>
              <button
                onClick={() => removeToast(toast.id)}
                className="text-text-quiet hover:text-text transition-colors p-1"
                aria-label="Dismiss"
              >
                <i className="fa-solid fa-xmark text-sm" />
              </button>
            </div>
          </Transition>
        );
      })}
    </div>
  );
}

export default ToastContainer;
